import { CHANGE_NEWS_TAB } from '../actionConstants/manualTradeConstants';

// eslint-disable-next-line
export const changeNewsTab = ({ tab }) => ({ type: CHANGE_NEWS_TAB, payload: { tab } });
